import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async";
import AdSenseUnit from "@/components/AdSenseUnit";
import ContentPageFooter from "@/components/ContentPageFooter";

const Guides = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-background text-foreground px-4 py-6 pb-24">
      <Helmet>
        <title>Movie & TV Guides – Ayeris</title>
        <meta
          name="description"
          content="Discover curated guides on movies, TV shows, and how to get the most out of Ayeris. Tips for movie nights, hidden gems, and more."
        />
        <link rel="canonical" href="https://ayeris.tv/guides" />
        <script type="application/ld+json">{JSON.stringify({
          "@context": "https://schema.org",
          "@type": "CollectionPage",
          "name": "Movie & TV Guides",
          "description": "Curated guides on movies, TV shows, and how to get the most out of Ayeris.",
          "url": "https://ayeris.tv/guides",
          "publisher": {
            "@type": "Organization",
            "name": "Ayeris",
            "url": "https://ayeris.tv"
          },
          "mainEntity": {
            "@type": "ItemList",
            "itemListElement": [
              { "@type": "ListItem", "position": 1, "name": "How to Host the Perfect Movie Night", "url": "https://ayeris.tv/guides#movie-night" },
              { "@type": "ListItem", "position": 2, "name": "Finding Hidden Gems", "url": "https://ayeris.tv/guides#hidden-gems" },
              { "@type": "ListItem", "position": 3, "name": "The Best Way to Use Group Sessions", "url": "https://ayeris.tv/guides#group-sessions" },
              { "@type": "ListItem", "position": 4, "name": "Making the Most of Your Watchlist", "url": "https://ayeris.tv/guides#watchlist" }
            ]
          }
        })}</script>
      </Helmet>

      <button
        onClick={() => navigate(-1)}
        className="flex items-center gap-1.5 text-muted-foreground hover:text-foreground transition mb-6"
      >
        <ArrowLeft className="w-4 h-4" />
        <span className="text-sm">{t("common.back", "Back")}</span>
      </button>

      <h1 className="text-2xl font-display font-bold mb-2">
        {t("guides.pageTitle")}
      </h1>
      <p className="text-sm text-muted-foreground mb-8">
        {t("guides.pageSubtitle")}
      </p>

      <article id="movie-night" className="mb-10">
        <h2 className="text-lg font-display font-semibold text-foreground mb-3">
          {t("guides.article1Title")}
        </h2>
        <div className="space-y-3 text-sm leading-relaxed text-secondary-foreground">
          <p>{t("guides.article1P1")}</p>
          <p>{t("guides.article1P2")}</p>
          <p>{t("guides.article1P3")}</p>
          <p>{t("guides.article1P4")}</p>
        </div>
      </article>

      <AdSenseUnit adSlot="5004064879" className="my-6" />

      <article id="hidden-gems" className="mb-10">
        <h2 className="text-lg font-display font-semibold text-foreground mb-3">
          {t("guides.article2Title")}
        </h2>
        <div className="space-y-3 text-sm leading-relaxed text-secondary-foreground">
          <p>{t("guides.article2P1")}</p>
          <p>{t("guides.article2P2")}</p>
          <p>{t("guides.article2P3")}</p>
          <p>{t("guides.article2P4")}</p>
        </div>
      </article>

      <article id="group-sessions" className="mb-10">
        <h2 className="text-lg font-display font-semibold text-foreground mb-3">
          {t("guides.article3Title")}
        </h2>
        <div className="space-y-3 text-sm leading-relaxed text-secondary-foreground">
          <p>{t("guides.article3P1")}</p>
          <p>{t("guides.article3P2")}</p>
          <p>{t("guides.article3P3")}</p>
          <p>{t("guides.article3P4")}</p>
          <p>{t("guides.article3P5")}</p>
        </div>
      </article>

      <AdSenseUnit adSlot="5004064879" className="my-6" />

      <article id="watchlist" className="mb-10">
        <h2 className="text-lg font-display font-semibold text-foreground mb-3">
          {t("guides.article4Title")}
        </h2>
        <div className="space-y-3 text-sm leading-relaxed text-secondary-foreground">
          <p>{t("guides.article4P1")}</p>
          <p>{t("guides.article4P2")}</p>
          <p>{t("guides.article4P3")}</p>
          <p>{t("guides.article4P4")}</p>
        </div>
      </article>

      <div className="mt-8 p-4 rounded-xl bg-secondary/50 border border-border text-center">
        <p className="text-sm text-muted-foreground mb-2">
          {t("guides.readyTitle")}
        </p>
        <button
          onClick={() => navigate("/landing")}
          className="text-sm text-primary font-medium hover:underline"
        >
          {t("guides.readyCta")} →
        </button>
      </div>

      <ContentPageFooter currentPath="/guides" />
    </div>
  );
};

export default Guides;
